import * as _ from 'lodash';
import { IContact, IListItem } from '@nkr/models/index';
import { Country } from '@nkr/enums/country';
import { IValidationDetails } from './validation';
import { Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import { FormEvent } from 'react';

interface IProps {
    mrn: string,
    email: string,
    surveyInstanceSkip: number,
    phone: string,
    firstName: string,
    lastName: string,
    country: number,
    addressLine1: string,
    city: string,
    state: number,
    nonUsStateProvince: string,
    postalCode: string,
    birthDate: string,
    gender: number,
    donationDate: string,
    heightSubFeet: number,
    heightSubInches: number,
    weightLbs: number,
    coordinatorContactId: number,
    dirty: boolean,
    validation: IValidationDetails,
    coordinatorList: IContact[],
    countryList: IListItem[],
    stateList: IListItem[],
    genderList: IListItem[],
    followUpSurveyInstanceList: IListItem[],
    onFieldChange: (field: string, value: any) => void
}

const DetailsContent = (props: IProps) => {
    const handleTextChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onFieldChange(e.currentTarget.name, e.currentTarget.value);
    };

    const handleSelectChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onFieldChange(e.currentTarget.name, e.currentTarget.value);
    };

    const heightFeetRange = _.range(4, 8);
    const heightInchesRange = _.range(0, 12);

    return (
        <Form horizontal>
            <FormGroup>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='mrn'><span className='label label-default'>optional</span> Donor's MRN:</Col>
                <Col xs={12} sm={8}>
                    <FormControl name='mrn' value={props.mrn} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            <FormGroup>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='email'>Send correspondence to:</Col>
                <Col xs={12} sm={8}>
                    <FormControl
                        componentClass='select'
                        name='coordinatorContactId'
                        value={props.coordinatorContactId}
                        onChange={handleSelectChange}
                    >
                        <option value={0}>- Send correspondence to donor -</option>
                        {props.coordinatorList.map((item, index) =>
                            <option key={'coord-' + index} value={item.id}>{item.fullName}</option>
                        )}
                    </FormControl>
                    {props.coordinatorContactId > 0 && (
                        <HelpBlock style={{ margin: 0, textAlign: 'right', fontSize: '85%' }}>All correspondence will be sent to this coordinator</HelpBlock>
                    )}
                </Col>
            </FormGroup>

            {props.coordinatorContactId == 0 && (
                <FormGroup validationState={props.dirty && props.validation.email == false ? 'error' : null}>
                    <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='email'>Donor's Email:</Col>
                    <Col xs={12} sm={8}>
                        <FormControl name='email' value={props.email} onChange={handleTextChange} />
                    </Col>
                </FormGroup>
            )}

            <FormGroup>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='surveyInstanceSkip'>Skip Survey Preference:</Col>
                <Col xs={12} sm={8}>
                    <FormControl componentClass='select' name='surveyInstanceSkip' value={props.surveyInstanceSkip} onChange={handleSelectChange}>
                        <option value={-1}>- Don't skip any surveys -</option>
                        {props.followUpSurveyInstanceList.map((item, index) =>
                            <option key={'skip-survey-' + index} value={item.id}>{item.description}</option>
                        )}
                    </FormControl>
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.phone == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='phone'>Phone:</Col>
                <Col xs={12} sm={8}>
                    <FormControl name='phone' value={props.phone} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.firstName == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='firstName'>First Name:</Col>
                <Col xs={12} sm={8}>
                    <FormControl name='firstName' value={props.firstName} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.lastName == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='lastName'>Last Name:</Col>
                <Col xs={12} sm={8}>
                    <FormControl name='lastName' value={props.lastName} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.country == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='country'>Country:</Col>
                <Col xs={12} sm={8}>
                    <FormControl componentClass='select' name='country' value={props.country} onChange={handleSelectChange}>
                        {props.countryList.map((item, index) =>
                            <option key={'country-' + index} value={item.id}>{item.description}</option>
                        )}
                    </FormControl>
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.addressLine1 == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='addressLine1'>Street Address:</Col>
                <Col xs={12} sm={8}>
                    <FormControl name='addressLine1' value={props.addressLine1} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.city == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel}>City</Col>
                <Col xs={12} sm={8}>
                    <FormControl name='city' value={props.city} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            {props.country == Country.UnitedStates ?
                <FormGroup validationState={props.dirty && props.validation.state == false ? 'error' : null}>
                    <Col xs={12} sm={4} componentClass={ControlLabel}>State</Col>
                    <Col xs={12} sm={8}>
                        <FormControl componentClass='select' name='state' value={props.state} onChange={handleSelectChange}>
                            <option value=''>- Please Select -</option>
                            {props.stateList.map((item, index) =>
                                <option key={'state-' + index} value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>
                :
                <FormGroup validationState={props.dirty && props.validation.nonUsStateProvince == false ? 'error' : null}>
                    <Col xs={12} sm={4} componentClass={ControlLabel}>State/Province</Col>
                    <Col xs={12} sm={8}>
                        <FormControl name='nonUsStateProvince' value={props.nonUsStateProvince} onChange={handleTextChange} />
                    </Col>
                </FormGroup>
            }

            <FormGroup validationState={props.dirty && props.validation.postalCode == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel}>Postal Code</Col>
                <Col xs={12} sm={8}>
                    <FormControl name='postalCode' value={props.postalCode} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.birthDate == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='birthdate'>Birth Date:</Col>
                <Col xs={12} sm={8}>
                    <FormControl type='date' name='birthDate' value={props.birthDate} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.gender == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='gender'>Gender:</Col>
                <Col xs={12} sm={8}>
                    <FormControl componentClass='select' name='gender' value={props.gender} onChange={handleSelectChange}>
                        <option value=''>- Please Select -</option>
                        {props.genderList.map((item, index) =>
                            <option key={'gender-' + index} value={item.id}>{item.description}</option>
                        )}
                    </FormControl>
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.donationDate == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='donationDate'>Donation Date:</Col>
                <Col xs={12} sm={8}>
                    <FormControl type='date' name='donationDate' value={props.donationDate} onChange={handleTextChange} />
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.heightSubFeet == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} >Height:</Col>
                <Col xs={6} sm={4}>
                    <label className='sr-only' htmlFor='heightSubFeet'>Height (feet)</label>
                    <div className="input-group">
                        <FormControl componentClass='select' name='heightSubFeet' value={props.heightSubFeet} onChange={handleSelectChange}>
                            <option value=''>- Select -</option>
                            {heightFeetRange.map((item, index) =>
                                <option key={'heightFeet-' + index} value={item}>{item}</option>
                            )}
                        </FormControl>
                        <div className="input-group-addon">
                            <div style={{ width: 23 }}>ft</div>
                        </div>
                    </div>
                    {/* <?= $form->getErrorTag('heightSubFeet', 'label label-danger') ?> */}
                </Col>
                <Col xs={6} sm={4}>
                    <label className='sr-only' htmlFor='heightSubInches'>Height (inches)</label>
                    <div className="input-group">
                        <FormControl componentClass='select' name='heightSubInches' value={props.heightSubInches} onChange={handleSelectChange}>
                            <option value=''>- Select -</option>
                            {heightInchesRange.map((item, index) =>
                                <option key={'heightInches-' + index} value={item}>{item}</option>
                            )}
                        </FormControl>
                        <div className="input-group-addon">
                            <div style={{ width: 23 }}>in</div>
                        </div>
                    </div>
                    {/* <?= $form->getErrorTag('heightSubInches', 'label label-danger') ?> */}
                </Col>
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.weightLbs == false ? 'error' : null}>
                <Col xs={12} sm={4} componentClass={ControlLabel} htmlFor='weightLbs'>Weight:</Col>
                <Col xs={12} sm={8}>
                    <div className='input-group'>
                        <FormControl name='weightLbs' value={props.weightLbs} onChange={handleTextChange} />
                        <div className="input-group-addon">
                            <div style={{ width: 23 }}>lbs</div>
                        </div>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    );
}

export default DetailsContent;